import Icon from "components/Icons/Icon";
import { t } from "i18n/index";
import { useMarketingLang } from "i18n/useMarketingLang";
import { getHomeTranslations } from "../marketing/i18n/pages/home";

// Elongated Stippl "S" rotated into a flat horizontal wave ribbon — same shape
// used by the redesign's WaveCTA (BlogPage.tsx's S_WAVE_PATH) to mask the photo band.
const S_WAVE_PATH =
	"M166.841 1269.22C143.15 1269.22 124.344 1294.46 124.803 1325.61C125.28 1356.73 144.852 1382 168.526 1382C192.217 1382 211.024 1356.73 210.564 1325.61C210.088 1294.46 190.515 1269.22 166.841 1269.22ZM626.774 426.901C730.286 390.192 771.524 308.445 771.607 214.234C771.727 86.4472 694.102 0 566.847 0C366.411 0 0 287.719 0 551.761C0 758.869 201.833 826.062 338.653 868.831C475.489 911.578 581.245 950.418 581.245 1000.91C581.245 1051.38 460.561 1165.13 266.184 1247.4C245.353 1256.64 233.182 1281.47 238.969 1302.86C244.773 1324.25 265.878 1331.83 287.187 1324.84C368.147 1298.21 750.215 1181.7 750.215 952.305C750.215 722.909 338.516 629.08 338.516 587.353C338.516 544.516 543.004 456.595 626.774 426.901Z";
const S_WAVE_VB = { w: 771.607, h: 1382 };
const S_WAVE_ASPECT = S_WAVE_VB.h / S_WAVE_VB.w;
const S_WAVE_MASK_URL = `url("data:image/svg+xml,${encodeURIComponent(
	`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${S_WAVE_VB.h} ${S_WAVE_VB.w}' preserveAspectRatio='none'><path transform='translate(0,${S_WAVE_VB.w}) rotate(-90)' d='${S_WAVE_PATH}' fill='black'/></svg>`
)}")`;

const BUSINESS_PHOTO = "https://images.unsplash.com/photo-1643029891412-92f9a81a8c16?fit=crop&auto=format&q=80&w=1800&h=900";

const BUSINESS_FEATURES = [
	{ key: "branded", fallback: "Branded itineraries" },
	{ key: "portals", fallback: "Client portals" },
	{ key: "reels", fallback: "Travel Reels" },
	{ key: "booking", fallback: "Booking tools" },
];

const BusinessWaveBanner = () => {
	const lang = useMarketingLang();
	const translations = getHomeTranslations(lang);

	return (
		<section className="business-wave-banner">
			<div className="business-wave-banner__inner">
				<div
					className="business-wave-banner__photo"
					style={{ aspectRatio: `${S_WAVE_ASPECT}`, WebkitMaskImage: S_WAVE_MASK_URL, maskImage: S_WAVE_MASK_URL }}
				>
					<img src={BUSINESS_PHOTO} alt="" loading="lazy" style={{ objectPosition: "50% 40%" }} />
				</div>

				<div className="business-wave-banner__card">
					<p className="sub-header">{t(translations, "home.businessBanner.subHeader", "Stippl for Business")}</p>
					<h2>
						{t(translations, "home.businessBanner.headingLine1", "The full tech stack for")}
						<br />
						{t(translations, "home.businessBanner.headingLine2", "your travel business")}
					</h2>
					<p className="business-wave-banner__body">
						{t(
							translations,
							"home.businessBanner.body",
							"White-label Stippl for your agency or tour operation: branded itineraries, client portals, Travel Reels and booking tools, all under your name."
						)}
					</p>
					<ul className="business-wave-banner__features">
						{BUSINESS_FEATURES.map((feature) => (
							<li key={feature.key}>
								<span className="business-wave-banner__check">
									<Icon name="check-small" size={11} stroke="white" />
								</span>
								{t(translations, `home.businessBanner.features.${feature.key}`, feature.fallback)}
							</li>
						))}
					</ul>
					<a href="https://business.stippl.io" className="btn-rounded xl">
						{t(translations, "home.businessBanner.cta", "Learn more →")}
					</a>
				</div>
			</div>
		</section>
	);
};

export default BusinessWaveBanner;
